import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './venueAnalysisPreview.png';

export const venueAnalysisDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                This chart analyzes venue volumes and your order&apos;s
                liquidity sourcing. It informs what venues the symbol typically
                trades in, today&apos;s breakdown and your order&apos;s venue
                usage.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'venue-analysis-preview' }],
};
